import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import ModuleProgressList from './ModuleProgressList';
import trueLinkCard from 'images/true-link-card.png';
import Logo from 'react/shared/components/Logo';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import theme from 'react/shared/theme/Theme';
import PALETTE from 'react/shared/theme/palette';
import currentModuleShape from 'react/signups/card/shapes/CurrentModule';
import userTypeShape from 'react/signups/card/shapes/UserType';

const useStyles = makeStyles(() => ({
  card: {
    borderRadius: '6px',
    boxShadow: `0 0 10px ${PALETTE.grey4}`,
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(1),
    height: '122px',
  },
  logo: {
    borderBottom: `1px solid ${PALETTE.grey6}`,
    padding: `${theme.spacing(4)} 0`,
    textAlign: 'center',
    width: '100%',
  },
  ordering: {
    '&.MuiTypography-root': {
      fontWeight: '600',
      marginTop: theme.spacing(2),
    },
  },
  progressStepper: {
    width: '75%',
  },
  wrapper: {
    height: '100vh',
  },
}));

export default function Sidebar({ cardholderFirstName, currentModule, userType }) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} role="complementary">
      <Grid alignItems="center" container direction="column" justifyContent="flex-start">
        <div className={classes.logo}>
          <Logo />
        </div>
        <Grid item>
          <img alt="True Link Visa Prepaid Card" className={classes.card} src={trueLinkCard} />
        </Grid>
        <Grid item>
          <CardText className={classes.ordering}>Ordering a card</CardText>
        </Grid>
        <Grid className={classes.progressStepper} item xs={9}>
          <ModuleProgressList
            cardholderFirstName={cardholderFirstName}
            currentModule={currentModule}
            userType={userType}
          />
        </Grid>
      </Grid>
    </div>
  );
}

Sidebar.propTypes = {
  cardholderFirstName: PropTypes.string,
  currentModule: currentModuleShape.isRequired,
  userType: userTypeShape.isRequired,
};
